import { createStyles } from 'core/utilities/theme';

export default createStyles({
  residueButton: {
    display: 'inline-block',
    margin: '0 2px 2px 0',
  },
  residueButtonColor: {
    position: 'absolute',
    right: '-3px',
    top: '2px',
  },
});
